const lazy = path => () => import(`./${path}`);

// 领取
export default [
  // 日结审核详情
  {
    path: "/myAccount",
    name: "myAccount",
    component: lazy("myAccount"),
    meta: {
      title: "我的账户",
      keepAlive: true
    }
  },
  {
    path: "/my/kefu",
    name: "myKeFu",
    component: lazy("kefu"),
    meta: {
      title: "客服",
      keepAlive: true
    }
  }
];
